import * as React from 'react'
import { theme } from '../../theme'

export interface Props {
  isOpen: boolean
  onClose: () => void
  onSave: () => void
  onDiscard: () => void
}

export const UnsavedChangesDialog = ({
  isOpen,
  onClose,
  onSave,
  onDiscard,
}: Props): JSX.Element | null => {
  // Track hover state for buttons
  const [saveHovered, setSaveHovered] = React.useState(false)
  const [discardHovered, setDiscardHovered] = React.useState(false)
  const [cancelHovered, setCancelHovered] = React.useState(false)

  if (!isOpen) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10001, // Higher than the editor modal
      }}
    >
      <div
        style={{
          backgroundColor: theme.colors.background,
          borderRadius: theme.borderRadius.md,
          padding: theme.spacing.lg,
          width: '400px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing.md,
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: '18px',
            color: theme.colors.text.primary,
          }}
        >
          Unsaved Changes
        </h2>

        <p
          style={{
            margin: 0,
            fontSize: '14px',
            color: theme.colors.text.secondary,
            lineHeight: '1.5',
          }}
        >
          You have unsaved changes. Would you like to save them before closing?
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: theme.spacing.md,
            marginTop: theme.spacing.md,
          }}
        >
          <button
            onClick={onDiscard}
            onMouseEnter={() => setDiscardHovered(true)}
            onMouseLeave={() => setDiscardHovered(false)}
            style={{
              padding: '8px 16px',
              borderRadius: theme.borderRadius.sm,
              border: `1px solid ${theme.colors.border}`,
              backgroundColor: discardHovered ? 'rgba(0, 0, 0, 0.05)' : theme.colors.background,
              color: theme.colors.text.secondary,
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'background-color 0.2s',
            }}
          >
            Discard
          </button>

          <button
            onClick={onClose}
            onMouseEnter={() => setCancelHovered(true)}
            onMouseLeave={() => setCancelHovered(false)}
            style={{
              padding: '8px 16px',
              borderRadius: theme.borderRadius.sm,
              border: `1px solid ${theme.colors.border}`,
              backgroundColor: cancelHovered ? 'rgba(0, 0, 0, 0.05)' : theme.colors.background,
              color: theme.colors.text.primary,
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'background-color 0.2s',
            }}
          >
            Cancel
          </button>

          <button
            onClick={onSave}
            onMouseEnter={() => setSaveHovered(true)}
            onMouseLeave={() => setSaveHovered(false)}
            style={{
              padding: '8px 16px',
              borderRadius: theme.borderRadius.sm,
              border: 'none',
              backgroundColor: saveHovered ? `${theme.colors.primary}dd` : theme.colors.primary,
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'background-color 0.2s',
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  )
}
